import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-sidenav-copyright',
    templateUrl: './sidenav-copyright.component.html',
    styleUrls: ['./sidenav-copyright.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SidenavCopyrightComponent implements OnInit {
  static readonly componentName = 'SidenavCopyrightComponent';
  
  @Input() copyright: string;

  constructor() {}

  ngOnInit() {}

  copyrightLeftPart(): string {
    const leftPart = this.copyright.substring(0, this.copyright.indexOf("(c)")).trim();

    return leftPart;
  }

  copyrightRightPart(): string {
    const rightPart = this.copyright.substring(this.copyright.indexOf("(c)") + 3, this.copyright.length).trim();

    return rightPart;
  }
}
